var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n")), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3,31.3c0.4,0.4,0.4,1.1,0,1.5L32.7,54.3c-0.4,0.4-1,0.4-1.4,0.1c0,0,0,0-0.1-0.1L9.6,32.7c-0.4-0.4-0.4-1.1,0-1.5 L31.3,9.7c0.4-0.4,1-0.4,1.4-0.1c0,0,0,0,0.1,0.1L54.3,31.3z M32,4c-0.5,0-1.1,0.2-1.4,0.6l-26,26c-0.8,0.8-0.8,2-0.1,2.8 c0,0,0,0,0.1,0.1l26,26c0.8,0.8,2.1,0.8,2.9,0l26-26c0.8-0.8,0.8-2,0.1-2.8c0,0,0,0-0.1-0.1l-26-26C33.1,4.2,32.5,4,32,4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,40.1v-10c0-0.4,0.3-0.7,0.7-0.7h13.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "35.1,19 45.3,29.2 35.1,39.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferTreatment);
export default __webpack_public_path__ + "static/media/transferTreatment.00b17763.svg";
export { ForwardRef as ReactComponent };